import React, { useState, useEffect } from "react";
import { useForm } from 'react-hook-form';

// components
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col, Nav, NavItem, NavLink, TabPane, TabContent } from "reactstrap";
import Select from 'react-select'
import Switch from "react-switch";

// services
import { showMessage } from "../../services/message.js";
import { api_GET, api_POST, api_PUT } from "../../services/api_service.js";
import ValidaAcessoFuncionalidadeAcao from "../../services/acesso.js";

//Context
import { useAuth } from "../../context/auth";

export default function UsuarioForm({ item, handleReturn }) {
    const {session, setLoading} = useAuth();

    const { register, handleSubmit, errors, setError, setValue, clearErrors, getValues } = useForm({ mode: "onBlur" });
    const [permiteEditar, set_permiteEditar] = React.useState(false);

    const [usuario_Id, set_usuario_Id] = React.useState(0);

    // Status
    const [status, set_status] = React.useState("");
    const [options_status] = React.useState([
        { value: "Ativo", label: "Ativo" },
        { value: "Inativo", label: "Inativo" },
    ]);
    const handleStatus = (value) => {
        set_status(value);
        setValue("status", value, true);
        clearErrors("status");
    }

    // Perfil
    const [perfil, set_perfil] = React.useState(null);
    const [options_perfil, set_options_perfil] = React.useState([]);
    const loadOptionsPerfil = () => {
        api_GET('perfil')
            .then(result => {
                set_options_perfil(result.data);
                if (item != null) {
                    let _perfil = result.data.filter(f => f.perfil_Id == item.perfil.perfil_Id)[0];
                    set_perfil(_perfil);
                    setValue("perfil", _perfil, true);
                }
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    };
    const handlePerfil = (value) => {
        set_perfil(value);
        setValue("perfil", value, true);
        clearErrors("perfil");
    }
    useEffect(() => {
        loadListFuncionalidades();
        loadListSetupSolicitacaoAcao();
    }, [perfil]);

    // Permissões de Acesso às telas
    const [list_funcionalidades, set_list_funcionalidades] = React.useState([]);
    const loadListFuncionalidades = () => {
        api_GET('usuario/getfuncionalidades')
            .then(result => {
                let funcionalidades = result.data;

                if (perfil != null) {
                    for (var i in funcionalidades) {
                        for (var j in funcionalidades[i].funcionalidadeAcoes) {
                            if (perfil.perfilFuncionalidadeAcao.filter(f => f.funcionalidadeAcao_Id == funcionalidades[i].funcionalidadeAcoes[j].funcionalidadeAcao_Id
                                && f.autorizado == true).length > 0) {
                                funcionalidades[i].funcionalidadeAcoes[j].autorizado = true;
                                funcionalidades[i].funcionalidadeAcoes[j].disabled = true;
                            }
                            else {
                                funcionalidades[i].funcionalidadeAcoes[j].autorizado = false;
                                funcionalidades[i].funcionalidadeAcoes[j].disabled = false;
                            }
                        }
                    }
                }

                if (item != null) {
                    for (var i in funcionalidades) {
                        for (var j in funcionalidades[i].funcionalidadeAcoes) {
                            if (item.usuarioFuncionalidadeAcoes.filter(f => f.autorizado == true
                                && f.funcionalidadeAcao_Id == funcionalidades[i].funcionalidadeAcoes[j].funcionalidadeAcao_Id).length > 0) {
                                funcionalidades[i].funcionalidadeAcoes[j].autorizado = true;
                            }
                        }
                    }
                }

                set_list_funcionalidades(funcionalidades);

            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }
    const handleChangeFuncionalidadeAcao = (funcionalidadeAcao, checked) => {
        funcionalidadeAcao.autorizado = checked;
        let funcionalidade = list_funcionalidades.filter(f => f.funcionalidade_Id == funcionalidadeAcao.funcionalidade_Id)[0];

        let new_funcionalidadeAcao = [];
        funcionalidade.funcionalidadeAcoes.map(m => {
            if (m.fucionalidadeAcao_Id == funcionalidadeAcao.funcionalidadeAcao_Id)
                new_funcionalidadeAcao.push(funcionalidadeAcao);
            else
                new_funcionalidadeAcao.push(m);
        });

        funcionalidade.funcionalidadeAcoes = new_funcionalidadeAcao;

        let new_list = [];
        list_funcionalidades.map(m => {
            if (m.funcionalidade_Id == funcionalidade.funcionalidade_Id)
                new_list.push(funcionalidade);
            else
                new_list.push(m);
        });
        set_list_funcionalidades(new_list);
    }
    const handleSalvarPermissoes = () => {
        if (usuario_Id == 0) {
            showMessage("Aviso", "Salve os dados do usuário antes de liberar as permissões!", 'error', null);
            return;
        }

        let usuario_permissoes = [];

        list_funcionalidades.map(f => {
            if (f.funcionalidadeAcoes != null) {
                f.funcionalidadeAcoes.map(a => {
                    if (a.autorizado && a.disabled != true) {
                        usuario_permissoes.push({
                            usuario_Id: usuario_Id,
                            funcionalidadeAcao_Id: a.funcionalidadeAcao_Id,
                            autorizado: a.autorizado
                        });
                    }
                })
            }
        })

        let json_submit = {
            usuario_Id: usuario_Id,
            email: "",
            login: "",
            nome: "",
            senha: "",
            status: "",
            usuarioUltimaAlteracao_Id: session.usuario_Id,
            usuarioFuncionalidadeAcoes: usuario_permissoes
        }

        setLoading(true);
        api_POST('usuario/PostPermissoes', json_submit)
            .then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', null))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    // Permissões de Acesso ao Setup Solicitação Ação
    const [list_setupsolicitacao, set_list_setupsolicitacao] = React.useState([]);
    const loadListSetupSolicitacaoAcao = () => {
        api_GET('setupsolicitacao')
            .then(result => {
                let setup = result.data;
                if (perfil != null) {
                    for (var i in setup) {
                        for (var j in setup[i].solicitacaoAcoes) {
                            if (perfil.perfilSetupSolicitacaoAcao.filter(f => f.setupSolicitacaoAcao_Id == setup[i].solicitacaoAcoes[j].setupSolicitacaoAcao_Id
                                && f.liberado == true).length > 0) {
                                setup[i].solicitacaoAcoes[j].liberado = true;
                                setup[i].solicitacaoAcoes[j].disabled = true;
                            }
                            else {
                                setup[i].solicitacaoAcoes[j].liberado = false;
                                setup[i].solicitacaoAcoes[j].disabled = false;
                            }
                        }
                    }
                }

                if (item != null && item.usuarioSetupSolicitacaoAcoes != null) {
                    for (var i in setup) {
                        for (var j in setup[i].solicitacaoAcoes) {
                            if (item.usuarioSetupSolicitacaoAcoes.filter(f => f.liberado == true
                                && f.setupSolicitacaoAcao_Id == setup[i].solicitacaoAcoes[j].setupSolicitacaoAcao_Id).length > 0) {
                                setup[i].solicitacaoAcoes[j].liberado = true;
                            }
                        }
                    }
                }
                set_list_setupsolicitacao(setup);
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }
    const handleChangeSetupSolicitacao = (setupSolicitacaoAcao, checked) => {
        setupSolicitacaoAcao.liberado = checked;
        let setup = list_setupsolicitacao.filter(f => f.setupSolicitacao_Id == setupSolicitacaoAcao.setupSolicitacao_Id)[0];

        let new_setupSolicitacaoAcao = [];
        setup.solicitacaoAcoes.map(m => {
            if (m.setupSolicitacaoAcao_Id == setupSolicitacaoAcao.setupSolicitacaoAcao_Id)
                new_setupSolicitacaoAcao.push(setupSolicitacaoAcao);
            else
                new_setupSolicitacaoAcao.push(m);
        });

        setup.solicitacaoAcoes = new_setupSolicitacaoAcao;

        let new_list = [];
        list_setupsolicitacao.map(m => {
            if (m.setupSolicitacao_Id == setupSolicitacaoAcao.setupSolicitacao_Id)
                new_list.push(setup);
            else
                new_list.push(m);
        });
        set_list_setupsolicitacao(new_list);
    }
    const handleSalvarSetupSolicitacao = () => {
        if (usuario_Id == 0) {
            showMessage("Aviso", "Salve os dados do usuário antes de liberar as permissões!", 'error', null);
            return;
        }

        let usuario_setupsolicitacaoacao = [];

        list_setupsolicitacao.map(f => {
            if (f.solicitacaoAcoes != null) {
                f.solicitacaoAcoes.map(a => {
                    if (a.liberado && a.disabled != true) {
                        usuario_setupsolicitacaoacao.push({
                            usuario_Id: usuario_Id,
                            setupSolicitacaoAcao_Id: a.setupSolicitacaoAcao_Id,
                            liberado: a.liberado
                        });
                    }
                })
            }
        })

        let json_submit = {
            usuario_Id: usuario_Id,
            email: "",
            login: "",
            nome: "",
            senha: "",
            status: "",
            usuarioUltimaAlteracao_Id: session.usuario_Id,
            usuarioSetupSolicitacaoAcoes: usuario_setupsolicitacaoacao
        }

        setLoading(true);
        api_POST('usuario/PostSetupSolicitacaoAcoes', json_submit)
            .then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', null))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const Voltar = (event, rowData) => {
        handleReturn();
    }

    const [h1_tab, set_h1_tab] = useState("ht1");

    const loadItem = () => {
        set_list_funcionalidades([]);
        if (item != null) {
            set_usuario_Id(item.usuario_Id);
            set_status(item.status);
            setValue("status", item.status, true);
            setValue("login", item.login);
            setValue("nome", item.nome);
            setValue("email", item.email);
        }
        else {
            set_usuario_Id(0);
            set_status("");
            setValue("status", "", false);
            set_perfil(null);
            setValue("perfil", "", false);
            setValue("login", "");
            setValue("nome", "");
            setValue("email", "");
        }
    }

    useEffect(() => {
        ValidaAcessoFuncionalidadeAcao("Usuarios.Editar", function (result) { set_permiteEditar(result) });
        loadOptionsPerfil();
        loadItem();
    }, []);

    const onSubmit = (data) => {
        let json_submit = {
            usuario_Id: usuario_Id,
            login: data.login,
            nome: data.nome,
            email: data.email,
            perfil_Id: perfil.perfil_Id,
            status: status,
            senha: Math.random().toString(36).slice(-8),
            usuarioUltimaAlteracao_Id: session.usuario_Id
        }

        setLoading(true);
        if (json_submit.usuario_Id == 0) {
            api_POST('usuario', json_submit)
                .then(result => {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', null);
                    set_usuario_Id(result.data.usuario_Id);
                })
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
        else {
            api_PUT('usuario', json_submit)
                .then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', null))
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
    }

    return (
        <>
            <div className="content">

                <Row>
                    <Col md="12">
                        <Button type="button" color="Primary" onClick={Voltar}><i className="fas fa-chevron-left"></i>  Voltar</Button>
                        <Card className="card-user">
                            <CardHeader>
                                <Row><Col md="12" className="text-right"><label className="text-danger">* Campos Obrigatórios</label></Col></Row>
                            </CardHeader>
                            <CardBody>
                                <Nav pills className="nav-pills-primary" style={{ cursor: "pointer" }}>
                                    <NavItem>
                                        <NavLink className={h1_tab === "ht1" ? "link-nav active" : "link-nav"} onClick={() => set_h1_tab("ht1")}><i class="fas fa-user"></i> Usuário </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink style={{ margin: "0px 10px" }} className={h1_tab === "ht2" ? "link-nav active" : "link-nav"} onClick={() => set_h1_tab("ht2")} ><i class="fas fa-sort-numeric-down"></i>  Lista de Permissões </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink style={{ margin: "0px 10px" }} className={h1_tab === "ht3" ? "link-nav active" : "link-nav"} onClick={() => set_h1_tab("ht3")} ><i class="fas fa-sort-numeric-down"></i>  Acesso às Solicitações </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={h1_tab} className="tab-space tab-principal">
                                    <TabPane tabId="ht1">
                                        <Row>
                                            <Col md="12">
                                                <Form onSubmit={handleSubmit(onSubmit)} className="formPrincipal">
                                                    <Row>
                                                        <Col md="6">
                                                            <FormGroup>
                                                                <b><label><span className="text-danger">*</span> Login</label> </b>
                                                                <Input type="text" name="login" maxLength={200} innerRef={register({ required: true })} ></Input>
                                                                {errors.login && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="6">
                                                            <FormGroup>
                                                                <b><label><span className="text-danger">*</span> Nome</label> </b>
                                                                <Input type="text" name="nome" maxLength={100} innerRef={register({ required: true })} ></Input>
                                                                {errors.nome && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="6">
                                                            <FormGroup>
                                                                <b><label><span className="text-danger">*</span> Email</label> </b>
                                                                <Input type="text" name="email" maxLength={200} innerRef={register({ required: true })} ></Input>
                                                                {errors.email && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="3" lg="3">
                                                            <FormGroup>
                                                                <b><label><span className="text-danger">*</span> Perfil</label> </b>
                                                                <Select
                                                                    options={options_perfil}
                                                                    getOptionLabel={option => option.descricao}
                                                                    getOptionValue={option => option.perfil_Id}
                                                                    name="perfil"
                                                                    onChange={(e) => { handlePerfil(e) }}
                                                                    value={perfil != null && options_perfil.find(obj => obj.perfil_Id === perfil.perfil_Id)}
                                                                    placeholder="Selecione"
                                                                    ref={e => register(
                                                                        { name: "perfil" },
                                                                        { required: true })
                                                                    }
                                                                />
                                                                {errors.perfil && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="3" lg="3">
                                                            <FormGroup>
                                                                <b><label><span className="text-danger">*</span> Status</label> </b>
                                                                <Select
                                                                    options={options_status}
                                                                    name="status"
                                                                    onChange={(e) => { handleStatus(e.value) }}
                                                                    value={status != "" && options_status.find(obj => obj.value === status)}
                                                                    placeholder="Selecione"
                                                                    ref={e => register(
                                                                        { name: "status" },
                                                                        { required: true })
                                                                    }
                                                                />
                                                                {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md="12" className="text-center">
                                                            <Button color="success" disabled={!permiteEditar} className="btn-mobile" type="submit"><i className="fas fa-save"></i>  Salvar</Button>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="ht2">
                                        <Row>
                                            {list_funcionalidades != null && list_funcionalidades.map((f, key) => {
                                                return <Col className="mt-4" md="12" key={{ key }}>
                                                    <label>{f.descricao}</label>
                                                    <Row>
                                                        {f.funcionalidadeAcoes != null && f.funcionalidadeAcoes.map((a, akey) => {
                                                            return <Col md="4" key={akey}>
                                                                <span>{a.descricao + " "} </span>
                                                                <Switch disabled={a.disabled} onChange={(event) => handleChangeFuncionalidadeAcao(a, event)} checked={a.autorizado} height={20} width={35} />
                                                            </Col>
                                                        })}
                                                    </Row>
                                                </Col>
                                            })}
                                        </Row>
                                        <Row>
                                            <Col md="12" className="text-center">
                                                <Button color="success" disabled={!permiteEditar} className="btn-mobile" type="button" onClick={handleSalvarPermissoes}><i className="fas fa-save"></i>  Salvar Permissões</Button>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="ht3">
                                        <Row>
                                            {list_setupsolicitacao != null && list_setupsolicitacao.map((f, key) => {
                                                return <Col className="mt-4" md="12" key={{ key }}>
                                                    <label>{f.descricao}</label>
                                                    <Row>
                                                        {f.solicitacaoAcoes != null && f.solicitacaoAcoes.map((a, akey) => {
                                                            return <Col md="4" key={akey}>
                                                                <span>{a.acao + " "} </span>
                                                                <Switch disabled={a.disabled} onChange={(event) => handleChangeSetupSolicitacao(a, event)} checked={a.liberado} height={20} width={35} />
                                                            </Col>
                                                        })}
                                                    </Row>
                                                </Col>
                                            })}
                                        </Row>
                                        <Row>
                                            <Col md="12" className="text-center">
                                                <Button color="success" disabled={!permiteEditar} className="btn-mobile" type="button" onClick={handleSalvarSetupSolicitacao}><i className="fas fa-save"></i>  Salvar Permissões Solicitação</Button>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                </TabContent>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>

        </>
    );
}

